const MAIN_PRODUCT_UTILS = (()=>{
  /**
   * Adds event listeners such that we can track changes to the selected options
   */
  function addOptionListeners() {
    // const variantPicker = isVariantPickerV1 ? new VariantPickerV1(sizeVariant, conditionVariant) : new VariantPickerV2();
    const variantPicker = new VariantPickerV2();

    // Size and condition selectors can be legitimately absent when the property was pruned (e.g. an
    // N/A-only size). Guard each so a missing selector skips its listeners rather than throwing and
    // aborting the rest of page setup.
    if (variantPicker.hasSelector('condition')) {
      const conditionRadios = variantPicker.getConditionSelector().options;
      if (!conditionRadios.length) {
        console.log('Unable to find condition options on the page');
      }
      for (let i = 0; i < conditionRadios.length; i++) {
        conditionRadios[i].addEventListener('change', changedVariant);
      }
    }
    if (variantPicker.hasSelector('size')) {
      const sizeRadios = variantPicker.getSizeSelector().options;
      if (!sizeRadios.length) {
        console.log('Unable to find size options on the page');
      }
      for (let i = 0; i < sizeRadios.length; i++) {
        sizeRadios[i].addEventListener('change', changedVariant);
      }
    }

    // Add event listener for select element
    const selectElement = document.getElementById('category-select');
    if (selectElement) {
      selectElement.addEventListener('change', changedVariant);
    }

    // Add event listener for the parent div
    const selectParent = document.getElementById('product-form__input-dropdown');
    if (selectParent) {
      selectParent.addEventListener('change', changedVariant);
    }
  }

  /**
   *
   */
  async function changedVariant() {
    updateAddToCartButton();
  }

  /**
   * Returns the list of selector properties that have no value selected.
   * Reads from each selector element's own .value rather than from filters,
   * so it stays accurate even immediately after conflict resolution deselects a property.
   * @returns {string[]}
   */
  function getMissingProperties() {
    if (!window.variants?.selectors?.length) {
      return [];
    }
    const missing = window.variants.selectors
      .filter(s => !s.value)
      .map(s => s.property);
    return missing;
  }

  /**
   * Updates the state of the add to cart button based on current selector state.
   * With v2 influence/conflict resolution, selectors always resolve to a valid
   * combination from availableVariants — so the button is either prompting for
   * missing selections or ready to add to cart.
   */
  function updateAddToCartButton() {
    const addToCartButtons = document.getElementsByClassName('add-to-cart-button');
    const missing = getMissingProperties();
    const hasAvailableVariants = Boolean(window?.variants?.data?.length);
    const isDisabled = !hasAvailableVariants || missing.length > 0;

    // Define labels
    let addToCartLabel = window.addToCartButtonSettings?.add_to_cart_label || "Add to Cart";
    const selectedVariant = SHOPIFY_UTILS.getSelectedVariant();
    if (selectedVariant) {
      addToCartLabel += ` - ${formatMoney(selectedVariant.price)}`;
    }
    const selectAllLabel = window.addToCartButtonSettings?.add_to_cart_select_all_options_label || "Select all options";
    const soldOutLabel = window.addToCartButtonSettings?.add_to_cart_sold_out_label || "Sold Out";

    let buttonLabel;
    switch (true) {
      case !hasAvailableVariants:
        buttonLabel = soldOutLabel;
        break;
      case missing.length > 1:
        buttonLabel = selectAllLabel;
        break;
      case missing.length === 1: {
        const prop = missing[0];
        buttonLabel = `Select a ${prop.charAt(0).toUpperCase() + prop.slice(1)}`;
        break;
      }
      default:
        buttonLabel = addToCartLabel;
    }

    Array.from(addToCartButtons).forEach(button => {
      button.disabled = isDisabled;
      button.innerText = buttonLabel;
    });

    document.getElementById('add-to-cart-message').innerText = '';
  }

  /**
  * To be called on page load to setup event listeners and initial button state
  */
  async function pageLoadEvents() {
    addOptionListeners();
    window.addEventListener('variants-updated', updateAddToCartButton);
    window.addEventListener('variants-ready', updateAddToCartButton);
    updateAddToCartButton();
  }

  return {
    pageLoadEvents,
    updateAddToCartButton,
  };
})();
